import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface MicPickerProps {}

export const MicPickerSetting: WidgetSettingFC<string, MicPickerProps> = ({
  data,
  setData,
  settings,
}) => {
  const [devices, setDevices] = useState<{ [id: string]: string }>({});
  const { permission } = settings;

  useEffect(() => {
    loadDevices();
  }, [permission]);

  const loadDevices = async () => {
    const deviceList = await navigator.mediaDevices.enumerateDevices();
    const filteredList = [];

    for (let device of deviceList) {
      if (Boolean(device.deviceId) && device.kind === "audioinput") {
        filteredList.push(device);
      }
    }

    setDevices(Object.fromEntries(filteredList.map((device) => [device.deviceId, device.label])));
  };

  const onDeviceSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setData(e.target.options[e.target.selectedIndex].value);
  };

  return (
    <OuterContainer>
      <FormLabel>Microphone</FormLabel>
      <Form.Control as="select" onChange={(e) => onDeviceSelected(e as any)} value={data}>
        {Object.keys(devices).map((deviceId) => (
          <option value={deviceId} key={deviceId}>
            {devices[deviceId]}
          </option>
        ))}
      </Form.Control>
    </OuterContainer>
  );
};

const OuterContainer = styled(Form.Group)`
  margin-bottom: 35px;
`;

const FormLabel = styled(Form.Label)`
  color: var(--secondary);
  font-weight: 600;
  font-size: 12pt;
`;
